import { useEffect } from 'react';
import type { RefObject } from 'react';

import { isEnterLeftToForm } from '../utils/is-enter-left-to-form.util';

// The wizards shown, the last one opened (a drawer over a page) in front.
const shownForms: RefObject<HTMLFormElement | null>[] = [];

const isInFront = (formRef: RefObject<HTMLFormElement | null>) =>
  shownForms[shownForms.length - 1] === formRef;

// Enter presses the main button of the wizard wherever the focus leaves it unhandled: the button
// keeps its own rules (disabled, memo asked before the submission).
export const useEnterPressesSubmit = (
  formRef: RefObject<HTMLFormElement | null>,
) => {
  useEffect(() => {
    // eslint-disable-next-line functional/immutable-data
    shownForms.push(formRef);

    const pressSubmit = (event: KeyboardEvent) => {
      const form = formRef.current;

      if (
        event.key !== 'Enter' ||
        event.defaultPrevented ||
        event.isComposing ||
        !form ||
        (event.target === document.body && !isInFront(formRef)) ||
        !isEnterLeftToForm(event.target, form)
      ) {
        return;
      }

      const submitButton = form.querySelector<HTMLButtonElement>(
        'button[type="submit"]:not(:disabled)',
      );

      if (!submitButton) {
        return;
      }

      event.preventDefault();
      submitButton.click();
    };

    document.addEventListener('keydown', pressSubmit);

    return () => {
      document.removeEventListener('keydown', pressSubmit);
      // eslint-disable-next-line functional/immutable-data
      shownForms.splice(shownForms.indexOf(formRef), 1);
    };
  }, [formRef]);
};
